'use client';
import Image from 'next/image';
import { ReactElement, memo, useEffect, useState } from 'react';

interface AccordionProps {
    title: ReactElement;
    content: ReactElement;
    iconPath?: string;
    iconSize?: number;
}

const Accordion = memo(({ title, content, iconPath, iconSize }: AccordionProps) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        setIsOpen(false);
    }, []);

    return (
        <div className="accordion" data-testid="accordion" id="accordion">
            <button
                className="accordion-header"
                data-testid="accordion-header"
                id="accordion-header"
                onClick={toggleAccordion}
                onKeyDown={toggleAccordion}
            >
                {title}
                <span data-testid="accordion-icon" id="accordion-icon">
                    <Image
                        alt="Ícone de seta"
                        title="Seta para expandir"
                        width={iconSize ?? 32}
                        height={iconSize ?? 32}
                        src={iconPath ?? `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/icon/icon-arrow-down.svg`}
                        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', cursor: 'pointer' }}
                    />
                </span>
            </button>
            {isOpen && (
                <div className="accordion-content" data-testid="accordion-content" id="accordion-content">
                    {content}
                </div>
            )}
        </div>
    );
});

export default Accordion;
